import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/satellite-platform',
        name: 'satellitePlatform',
        component: () => import('../views/SatellitePlatformView.vue'),
    },
    {
        path: '/satellite-manufacturing',
        name: 'satelliteManufacturing',
        component: () => import('../views/SatelliteManufacturingView.vue'),
    },
    {
        path: '/application',
        name: 'application',
        component: () => import('../views/ApplicationView.vue'),
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/newsId/:newsId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/ServiceView.vue')
    },
    {
        path: '/careers',
        name: 'careers',
        component: () => import('../views/CareerView.vue')
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('../views/PolicyView.vue')
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果有保存的位置（如浏览器的前进后退），则恢复到该位置
        if (savedPosition) {
            return savedPosition
        }
        // 否则滚动到页面顶部
        return { x: 0, y: 0 }
    }
})

export default router
